import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingCtx = createContext(null);

export function BrandingProvider({ children }) {
    const [software, setSoftware] = useState(null);
    const [organization, setOrganization] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadSoftware = useCallback(async () => {
        try {
            const { data } = await api.get("/branding/software");
            setSoftware(data);
        } catch {
            setSoftware(null);
        }
    }, []);

    const loadOrganization = useCallback(async () => {
        const t = localStorage.getItem("bdo_access");
        if (!t) {
            setOrganization(null);
            return;
        }
        try {
            const { data } = await api.get("/branding/organization");
            setOrganization(data);
        } catch {
            setOrganization(null);
        }
    }, []);

    useEffect(() => {
        (async () => {
            await Promise.all([loadSoftware(), loadOrganization()]);
            setLoading(false);
        })();
    }, [loadSoftware, loadOrganization]);

    return (
        <BrandingCtx.Provider value={{ software, organization, loading, reloadOrg: loadOrganization, reloadSoftware: loadSoftware }}>
            {children}
        </BrandingCtx.Provider>
    );
}

export const useBranding = () => useContext(BrandingCtx);
